import {
  CircleDot, Bot, Clock, Hand, PhoneCall, PhoneOutgoing, UserCog, Sparkles, PauseCircle,
} from "lucide-react";

/**
 * Centralized visual mapping for Agency Case operational/ai status. Keep badge
 * logic here (not scattered in cards). Returns null when no badge should show.
 */
const OPERATIONAL = {
  new: { label: "Nuovo", Icon: CircleDot, cls: "bg-slate-100 text-slate-600 border-slate-200" },
  ai_handling: { label: "AI in gestione", Icon: Bot, cls: "bg-violet-100 text-violet-700 border-violet-200" },
  waiting_customer: { label: "In attesa cliente", Icon: Clock, cls: "bg-amber-100 text-amber-700 border-amber-200" },
  human_action_required: { label: "Intervento richiesto", Icon: Hand, cls: "bg-rose-100 text-rose-700 border-rose-200" },
  ready_to_call: { label: "Da chiamare", Icon: PhoneCall, cls: "bg-blue-100 text-blue-700 border-blue-200" },
  callback_scheduled: { label: "Richiamo programmato", Icon: Clock, cls: "bg-cyan-100 text-cyan-700 border-cyan-200" },
  calling: { label: "Chiamata in corso", Icon: PhoneOutgoing, cls: "bg-green-100 text-green-700 border-green-200" },
  human_takeover: { label: "Gestione manuale", Icon: UserCog, cls: "bg-indigo-100 text-indigo-700 border-indigo-200" },
  idle: null,
  closed: null,
};

export function getAgencyOperationalBadge(caseObj) {
  if (!caseObj) return null;
  return OPERATIONAL[caseObj.operational_status] || null;
}

export function getAiBadge(caseObj) {
  if (!caseObj) return null;
  if (caseObj.ai_status === "active") {
    return { label: "AI", Icon: Sparkles, cls: "bg-violet-100 text-violet-700 border-violet-200" };
  }
  if (caseObj.ai_status === "paused_by_human") {
    return { label: "AI in pausa", Icon: PauseCircle, cls: "bg-slate-100 text-slate-500 border-slate-200" };
  }
  return null;
}
